import './styles/Site.scss';
import ComboCard from './scripts/paywall/components/comboCard';
import PaywallAnimations from './scripts/paywall/animations/paywallAnimations';
import { model } from './scripts/paywall/core/model'
import Router from './scripts/paywall/controllers/router'
import { Config } from './scripts/paywall/core/config'

import segmentation from './scripts/paywall/handlers/segmentation';
import loggedin from './scripts/paywall/controllers/loggedIn'
import libs from './scripts/paywall/libs/index'
import Analitycs from './scripts/paywall/helpers/analytics'
import Hotjar from './scripts/paywall/helpers/hotjar'
import CustomDimension from './scripts/paywall/helpers/customDimension'
import Error from './scripts/paywall/controllers/error'
import abTesting from './scripts/paywall/helpers/abTesting';

const start = () => {  
    window.LN = window.LN || {};
    window.LN.Model = model;
    window.LN.Config = Config;

    segmentation.resolveSegmentation();

    loggedin();
    Router.init();
    ComboCard.init();
    PaywallAnimations.init();
    libs();
    CustomDimension();
    abTesting.chooseVariant();
    Analitycs.pushDelayed();
    Hotjar.pushDelayed();
};

start();



// WEBPACK FOOTER //
// ./Statics/paywall.js